module.exports = __webpack_public_path__ + "media/landing_work/home/images/independence-bb55beabe7336b26ac4f824780307667.png";